import { create } from 'zustand'
import { getMyFavorites, addFavorite, removeFavorite } from '@/services/favoriteService'

interface FavoriteState {
  favoriteIds: Set<number>
  loaded: boolean
  fetchFavorites: () => Promise<void>
  toggleFavorite: (courseId: number) => Promise<void>
  clear: () => void
}

// เก็บ favorite แค่ course_id ไว้ในหน่วยความจำ (ไม่ persist ลง localStorage — โหลดจาก server ใหม่ทุกครั้งที่ login)
// ใช้ Set แทน array เพื่อเช็ค isFavorited(courseId) แบบ O(1) ใน CourseCard ที่ render ซ้ำเยอะ
export const useFavoriteStore = create<FavoriteState>((set, get) => ({
  favoriteIds: new Set(),
  loaded: false,

  fetchFavorites: async () => {
    try {
      const favorites = await getMyFavorites()
      set({ favoriteIds: new Set(favorites.map((f) => f.course_id)), loaded: true })
    } catch {
      set({ loaded: true })
    }
  },

  toggleFavorite: async (courseId: number) => {
    const isFavorited = get().favoriteIds.has(courseId)
    // optimistic update — เปลี่ยน UI ทันที แล้วค่อยยิง API ตาม (rollback ถ้าพัง)
    set((state) => {
      const next = new Set(state.favoriteIds)
      if (isFavorited) next.delete(courseId)
      else next.add(courseId)
      return { favoriteIds: next }
    })
    try {
      if (isFavorited) await removeFavorite(courseId)
      else await addFavorite(courseId)
    } catch {
      set((state) => {
        const next = new Set(state.favoriteIds)
        if (isFavorited) next.add(courseId)
        else next.delete(courseId)
        return { favoriteIds: next }
      })
    }
  },

  clear: () => set({ favoriteIds: new Set(), loaded: false }),
}))
